import SectionHeading from './SectionHeading';
import { speedReports, type SpeedReport } from '@/mocks/material';

const kindStyle: Record<SpeedReport['kind'], string> = {
  入档: 'bg-primary-100 text-primary-700',
  补线索: 'bg-accent-100 text-accent-700',
  复盘: 'bg-secondary-100 text-secondary-700',
  旧料重检: 'bg-background-200 text-foreground-600',
};

export default function SpeedReport() {
  return (
    <section id="speed" className="mx-auto max-w-[1240px] scroll-mt-24 px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        index="01"
        kicker="本期速报"
        title="今天，又有哪笔旧账被补齐"
        desc="每天把刚入档、新补的线索、刚做完的复盘整理成速报。标题点开即看正文，页码与原件都标在后面。"
        linkText="查看全部速报"
      />

      <div className="mt-10 grid gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-2 lg:grid-cols-3">
        {speedReports.map((r) => (
          <article
            key={r.id}
            className="group flex flex-col justify-between gap-6 bg-background-50 p-5 transition-colors hover:bg-background-100 md:p-6"
          >
            <div>
              <div className="flex items-center justify-between gap-3">
                <span className={`whitespace-nowrap rounded-sm px-2 py-0.5 text-[11px] font-semibold ${kindStyle[r.kind]}`}>
                  {r.kind}
                </span>
                <span className="text-[11px] text-foreground-400">{r.time}</span>
              </div>
              <h3 className="font-heading mt-4 text-base font-bold leading-snug text-foreground-950 md:text-lg">
                {r.title}
              </h3>
              <p className="mt-2 text-xs leading-6 text-foreground-600 md:text-[13px]">{r.excerpt}</p>
            </div>

            <div className="flex items-center justify-between">
              <div className="flex flex-wrap gap-1.5">
                {r.tags.map((t) => (
                  <span key={t} className="rounded-sm bg-background-200/80 px-1.5 py-0.5 text-[11px] text-foreground-500">
                    {t}
                  </span>
                ))}
              </div>
              <button
                type="button"
                aria-label="打开条目"
                className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-background-200 text-foreground-500 transition-colors group-hover:border-primary-300 group-hover:text-primary-600"
              >
                <i className="ri-corner-down-right-line text-sm" />
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}